/*
 * File: About.js
 * Project: moovee
 * File Created: Saturday, 16th May 2020 6:37:57 pm
 * Author: Adithya Sreyaj
 * -----
 * Last Modified: Saturday, 16th May 2020 6:39:07 pm
 * Modified By: Adithya Sreyaj<adi.sreyaj@gmail.com>
 * -----
 */

import React from 'react';

export default function About() {
  return <div>About Page</div>;
}
